import { DIM_STYLE } from "@/components/Badges";

const DIM_LABEL = { direzione: "Direzione", continuita: "Continuità", spazio: "Spazio", ricarica: "Ricarica", motivazione: "Motivazione", mentalita: "Mentalità" };
const LVL_LABEL = { ripartire: "Base", stabilizzare: "Intermedio", potenziare: "Avanzato" };
const ORDER = ["direzione", "continuita", "spazio", "ricarica", "motivazione", "mentalita"];
export const SITE = "coach2go.minocesari.com";

function Radar({ scores, focus }) {
  const cx = 150, cy = 130, R = 88;
  const pt = (i, r) => {
    const a = (Math.PI * 2 * i) / 6 - Math.PI / 2;
    return [cx + r * Math.cos(a), cy + r * Math.sin(a)];
  };
  const ring = (f) => ORDER.map((_, i) => pt(i, R * f).join(",")).join(" ");
  const vals = ORDER.map((k, i) => pt(i, R * Math.max(0.12, Math.min(1, (scores[k] || 0) / 15))));
  return (
    <svg width="300" height="260" viewBox="0 0 300 260" data-testid="share-card-radar">
      {[1 / 3, 2 / 3, 1].map((f) => <polygon key={f} points={ring(f)} fill="none" stroke="rgba(212,175,55,0.18)" strokeWidth="1" />)}
      {ORDER.map((_, i) => { const [x, y] = pt(i, R); return <line key={i} x1={cx} y1={cy} x2={x} y2={y} stroke="rgba(212,175,55,0.12)" />; })}
      <polygon points={vals.map((v) => v.join(",")).join(" ")} fill="rgba(212,175,55,0.22)" stroke="#E5C158" strokeWidth="2" strokeLinejoin="round" />
      {ORDER.map((k, i) => {
        const [x, y] = vals[i];
        const [lx, ly] = pt(i, R + 22);
        const c = DIM_STYLE[k].c;
        const isF = k === focus;
        return (
          <g key={k}>
            {isF && <circle cx={x} cy={y} r="9" fill="none" stroke={c} strokeWidth="1.5" opacity="0.7" />}
            <circle cx={x} cy={y} r={isF ? 5 : 3.5} fill={c} />
            <text x={lx} y={ly + 4} textAnchor="middle" fontSize={isF ? 12.5 : 11.5} fontWeight={isF ? 700 : 600} fill={isF ? c : "#A1A1AA"} fontFamily="inherit">{DIM_LABEL[k]}</text>
          </g>
        );
      })}
    </svg>
  );
}

export function ShareCardStory({ innerRef, arch, dimension, level, logo, scores }) {
  const accent = DIM_STYLE[dimension]?.c || "#D4AF37";
  const Icon = DIM_STYLE[dimension]?.icon;
  const name = arch.title.replace(/^Profilo\s+/i, "");
  const hasScores = scores && ORDER.every((k) => typeof scores[k] === "number");
  return (
    <div ref={innerRef} style={{ width: 360, height: 640, background: "#09090B" }} className="relative overflow-hidden" data-testid="share-card">
      <div style={{ position: "absolute", inset: 0, background: `radial-gradient(70% 40% at 50% 50%, ${accent}22, transparent 70%), radial-gradient(90% 35% at 50% 0%, rgba(212,175,55,0.16), transparent 70%), radial-gradient(90% 30% at 50% 100%, rgba(212,175,55,0.14), transparent 70%)` }} />
      <div style={{ position: "absolute", inset: 14, borderRadius: 22, border: "1px solid rgba(212,175,55,0.3)" }} />
      <div className="relative flex h-full flex-col items-center text-center" style={{ padding: "34px 30px 30px" }}>
        {logo ? <img src={logo} alt="Coach2Go" style={{ height: 24, width: "auto" }} /> : <span style={{ height: 24 }} />}
        <p style={{ color: "#D4AF37", fontSize: 11, letterSpacing: "0.2em", marginTop: 26 }} className="font-bold uppercase">Il mio profilo</p>
        <h1 style={{ fontSize: name.length > 16 ? 36 : 42, lineHeight: 1.02, color: "#FAF9F6", marginTop: 8 }} className="font-serif-el font-semibold" data-testid="share-card-name">{name}</h1>
        <p style={{ fontSize: 15, lineHeight: 1.4, color: "#D4D4D8", marginTop: 10, maxWidth: 270 }} className="font-medium">{arch.subtitle}</p>
        <div style={{ marginTop: 6 }} className="flex flex-1 items-center justify-center">
          {hasScores ? (
            <Radar scores={scores} focus={dimension} />
          ) : (
            Icon && (
              <div style={{ width: 120, height: 120, borderRadius: 32, border: `1px solid ${accent}66`, background: `${accent}18`, color: accent }} className="flex items-center justify-center">
                <Icon size={56} strokeWidth={1.5} />
              </div>
            )
          )}
        </div>
        <p style={{ fontSize: 12.5, color: "#A1A1AA" }}>
          Area da allenare: <span style={{ color: accent, fontWeight: 700 }}>{DIM_LABEL[dimension]}</span> · Livello {LVL_LABEL[level]}
        </p>
        <div style={{ marginTop: 16, width: "100%", borderRadius: 18, border: "1px solid rgba(212,175,55,0.45)", background: "rgba(212,175,55,0.08)", padding: "16px 14px" }}>
          <p style={{ fontSize: 24, lineHeight: 1.1, color: "#FAF9F6" }} className="font-serif-el font-semibold">E tu che profilo sei?</p>
          <p style={{ fontSize: 12.5, color: "#D4D4D8", marginTop: 6 }}>Scoprilo in 2 minuti, con 18 domande</p>
          <p style={{ fontSize: 14, color: "#E5C158", marginTop: 10, letterSpacing: "0.02em" }} className="font-bold">{SITE}</p>
        </div>
      </div>
    </div>
  );
}
